export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-background-900 to-background-800">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20elegant%20background%20with%20subtle%20gradient%20texture%2C%20modern%20technology%20pattern%20with%20soft%20red%20and%20golden%20accent%20lines%2C%20minimalist%20abstract%20design%2C%20warm%20atmospheric%20lighting%2C%20cinematic%20dark%20theme&width=1400&height=500&seq=app-bg-90movies&orientation=landscape"
              alt=""
              className="w-full h-full object-cover opacity-30"
            />
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-14">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/15 rounded-full border border-accent-500/25 mb-4 whitespace-nowrap">
                📱 移动端专属
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white">
                90影视 APP
              </h2>
              <p className="mt-3 text-sm md:text-base text-white/60 leading-relaxed max-w-[500px] mx-auto lg:mx-0">
                下载90影视APP，随时随地畅享高清观影体验。支持离线缓存、倍速播放、弹幕互动，手机追剧更便捷。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-6">
                <div className="flex items-center gap-1.5 text-white/70 text-xs">
                  <i className="ri-checkbox-circle-fill text-green-400 w-4 h-4 flex items-center justify-center"></i>
                  <span>高清画质</span>
                </div>
                <div className="flex items-center gap-1.5 text-white/70 text-xs">
                  <i className="ri-checkbox-circle-fill text-green-400 w-4 h-4 flex items-center justify-center"></i>
                  <span>离线缓存</span>
                </div>
                <div className="flex items-center gap-1.5 text-white/70 text-xs">
                  <i className="ri-checkbox-circle-fill text-green-400 w-4 h-4 flex items-center justify-center"></i>
                  <span>无广告</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
                <a
                  href="#app"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-foreground-900 text-sm font-semibold rounded-md hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg w-5 h-5 flex items-center justify-center"></i>
                  iOS 下载
                </a>
                <a
                  href="#app"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill text-lg w-5 h-5 flex items-center justify-center"></i>
                  Android 下载
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-[200px] md:w-[240px] aspect-[9/16] rounded-2xl overflow-hidden border-2 border-white/20">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20movie%20streaming%20app%20UI%20mockup%20on%20a%20smartphone%20screen%2C%20dark%20theme%20interface%20with%20movie%20poster%20thumbnails%2C%20warm%20red%20and%20golden%20accent%20colors%2C%20clean%20modern%20design%2C%20cinematic%20layout%2C%20minimalist%20app%20interface&width=480&height=854&seq=app-mockup-90movies&orientation=portrait"
                  alt="90影视APP界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}